import { render } from "./FileMoveDialog.vue?vue&type=template&id=ddc24548"
import script from "./FileMoveDialog.vue?vue&type=script&lang=js"
export * from "./FileMoveDialog.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__